export default __webpack_public_path__ + "static/media/referee.c8de23c5.svg";